import {
  Component,
} from "react";
import {
  withLocation,
} from "CommonCore/router-util";
import _ from "lodash";
import {
  EditPanel,
  Spinner,
} from "CommonComponents/bricks";
import store from "CommonState/store";
import antragApi from "Apis/antrag-api";
import {
  createInjectsSelector,
  injectsFromSchema,
} from "CommonCore/schema-util";
import apifetch from "CommonCore/apifetch";
import {
  schema,
} from "Apis/antrag-pruefvermerk-api";
import {
  ROLLEN,
} from "App/constants";
import {
  customControls,
} from "App/shk-form-tab";

const injects = injectsFromSchema(schema);
const selectInjects = createInjectsSelector(injects);

@withLocation
@store(...injects, "user")
@antragApi.current
export default class AntragPruefvermerkTab extends Component {
  constructor() {
    super();
    this.state = { avtdaten: "(leer)" };
  }

  load = async function(antrag) {
    const url = `/api/shkantrag/antragvortrag/pruefvermerk/${ antrag.a_id }`;
    const result = await apifetch(url);
    this.setState({ avtdaten: result && _.isEmpty(result.data) ? {} : result.data[0] });
  };

  componentDidMount = () => {
    this.load(this.props.currentAntrag);
  };

  onSave = async entity => {
    const { currentAntrag } = this.props;
    entity.avt_aid = currentAntrag.a_id;
    await apifetch(`/api/shkantrag/antragvortrag/pruefvermerk`, {
      method: "POST",
      body: JSON.stringify(entity),
    });
    this.load(currentAntrag);
  };

  render() {
    const { avtdaten } = this.state;
    const { user } = this.props;

    const istAussenwirtschaft = (user.ro_id == ROLLEN.ROLLE_AUSSENWIRTSCHAFT);

    return avtdaten == "(leer)"
      ? <Spinner />
      : <EditPanel
        editable={istAussenwirtschaft}
        customControls={customControls}
        entity={avtdaten}
        header={<h4 key='h4'>{schema.displayName}</h4>}
        schema={schema}
        onSave={this.onSave}
        injects={selectInjects(this.props)} />;
  }
}
